<template>
    <div class="bg-white px-3 index" >
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="商城数据" name="1">
                <shopData :mall_VisCount="mall_VisCount" :mall_Transactione="mall_Transactione" />
            </el-tab-pane>
            <el-tab-pane label="商城流量" name="2">
                <shopFlow :mall_Flow="mall_Flow" />
            </el-tab-pane>
            <el-tab-pane label="商品数据" name="3">
                <goodsData />
            </el-tab-pane>
            <el-tab-pane label="老客与客服" name="4">
                <oldKekefu />
            </el-tab-pane>
            <el-tab-pane label="积分0兑" name="5">
                <lingbuy />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import shopData from "./tabs/shopData.vue";
    import shopFlow from "./tabs/shopFlow.vue";
    import goodsData from "./tabs/goodsData.vue";
    import lingbuy from "./tabs/lingbuy.vue";
    import oldKekefu from "./tabs/oldKekefu.vue";
    import {
        mapState
    } from 'vuex'
    import router from "../../../router";

    export default {
        components: {
            shopData,
            shopFlow,
            goodsData,
            oldKekefu,
            lingbuy,
        },
        data() {
            return {
                activeName: '1',
                mall_VisCount:'',
                mall_Transactione:{},
                mall_Flow:{}
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        filters: {

        },
        mounted() {
            let that = this;
            this.connect()
        },
        methods: {
            handleClick() {},

            async connect() {
                let that = this
                that.$openws.ws.homePage = function (text,type) {
                    if (text.msg_source == 'homePage') {
                        if (text.modular == 'mall_Transactione') {
                            that.mall_Transactione = text.data
                        }
                        if (text.modular == 'mall_Flow') {
                            that.mall_Flow = text.data
                            that.mall_VisCount = text.data.mall_vis ? text.data.mall_vis : '0'

                        }

                    }
                };
                // 接诊提醒
				that.$openws.ws.inquiryRemind = function (text, type) {
					this.$notify.info({
						title: '新咨询订单',
						message: text.data,
						position: 'bottom-right',
					});
				};
                /*that.$openws.ws.msg = async function (user_id, kefu_id, text) {
                    if (text.msg_source == 'homePage') {
                        if (text.modular == 'mall_Transactione') {
							that.mall_Transactione = text.data
						}
                        if (text.modular == 'mall_Flow') {
                            that.mall_Flow = text.data
                            that.mall_VisCount = text.data.mall_vis ? text.data.mall_vis : '0'
                           
                        }

                    }
                };*/
            },


        },
        destroyed() {
            this.$openws.connect()
        },
    }
</script>

<style lang="scss" scoped>
.index{
    padding-top: 10px;
}
</style>